export class FotterAcodion {
  constructor() {
    this.$lists = document.querySelectorAll('.js-footer-lists');
    this.$sublists = document.querySelectorAll('.js-footer-sublists');

    this.$items = this._getItem(this.$lists, '.p-footer__map-item');
    this.$subitems = this._getItem(this.$sublists, '.p-footer__map-subitem');

    this.$buttons = document.querySelectorAll('.js-lists-button');
    this.$subbuttons = document.querySelectorAll('.js-sublists-button');

    this.eventType = this._getEventType();
    this._init();
  }

  _getEventType() {
    const isTouchCapable =
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof DocumentTouch);

    return isTouchCapable ? 'touchstart' : 'click';
  }

  _getItem(lists, itemClass) {
    const items = [];
    lists.forEach((list) => {
      const item = list.querySelectorAll(itemClass);
      items.push(...item);
    });

    return items;
  }

  _toggle(el) {
    el.classList.toggle('is-open');
  }

  _removeSublistsClass(el) {
    const sublists = el.querySelectorAll('.js-footer-sublists');
    sublists.forEach((list) => {
      this._slideUp(list);
      list.classList.remove('is-open');
    });
  }

  _removeSubButtonClass(el) {
    const subbuttons = el.querySelectorAll('.js-sublists-button');
    subbuttons.forEach((subbutton) => {
      subbutton.classList.remove('is-open');
    });
  }

  _buttonAction(el) {
    const parent = el.parentNode;
    const list = parent.querySelector('.js-footer-lists');

    if (list.classList.contains('is-open')) {
      this._removeSublistsClass(list);
      this._removeSubButtonClass(list);
      this._slideUp(list);
    } else {
      this._slideDown(list);
    }
    this._toggle(list);
    this._toggle(el);
  }

  _subButtonAction(el) {
    const parent = el.parentNode;
    const list = parent.querySelector('.js-footer-sublists');

    if (list.classList.contains('is-open')) {
      this._slideUp(list);
      this._toggle(list);
      this._toggle(el);
    } else {
      this._slideDown(list);
      this._toggle(list);
      this._toggle(el);
    }
  }

  // メニューを開く関数
  _slideDown(el) {
    el.style.height = 'auto'; //いったんautoに
    let h = el.offsetHeight; //autoにした要素から高さを取得
    el.style.height = h + 'px';
    el.animate(
      {
        //高さ0から取得した高さまでのアニメーション
        height: [0, h + 'px'],
      },
      {
        duration: 300, //アニメーションの時間（ms）
      }
    );
    el.style.height = 'auto'; //ブラウザの表示幅を途中で閲覧者が変えた時を考慮してautoに戻す
  }

  // メニューを閉じる関数
  _slideUp(el) {
    let h = el.offsetHeight;
    el.style.height = h + 'px';
    el.animate(
      {
        height: [h + 'px', 0],
      },
      {
        duration: 300,
      }
    );
    el.style.height = 0;
  }

  _init() {
    this.$buttons.forEach((button) => {
      button.addEventListener(this.eventType, (event) => {
        this._buttonAction(button);
      });
    });

    this.$subbuttons.forEach((button) => {
      button.addEventListener(this.eventType, (event) => {
        this._subButtonAction(button);
      });
    });
  }
}
